import { createSelector } from '@reduxjs/toolkit';
import {
  selectProjectsDetails,
  selectOptionsPages,
  selectOptionsPlusTotal,
  selectOptionsPercentTotal,
} from '../project/projectSelectros';

export const selectWordpressSeparatePage = createSelector(
  selectProjectsDetails,
  projectsDetails => projectsDetails?.wordpressSeparatePage || {}
);

export const selectWordpressSeparatePageCalculationParams = createSelector(
  selectWordpressSeparatePage,
  projectOther => projectOther.calculationOptions || {}
);

export const selectWordpressSeparatePagePagesTotal = createSelector(
  selectOptionsPages,
  (options) => {
    return {
      discount: 0,
      totalPricePages: options.reduce((accumulator, currentValue) => accumulator + currentValue.total, 0)
    }
  }
);

export const selectWordpressSeparatePageOptionsTotal = createSelector(
  selectWordpressSeparatePagePagesTotal,
  selectOptionsPlusTotal,
  selectOptionsPercentTotal,
  ({totalPricePages}, totalPricePlusOptions, totalPricePercentOptions) => {
    const  totalPriceOfPercent = Math.ceil((totalPricePercentOptions / 100) * totalPricePages);
    return totalPriceOfPercent + totalPricePlusOptions;
  }
);

export const selectWordpressSeparatePageTotal = createSelector(
  selectWordpressSeparatePagePagesTotal,
  selectWordpressSeparatePageOptionsTotal,
  ({totalPricePages}, totalPriceOptions) => totalPricePages + totalPriceOptions
);

export const selectWordpressSeparatePageTotalForAsap = createSelector(
    selectWordpressSeparatePageTotal,
    (totalPrice) => {
        return totalPrice / 2;
    }
);

export const selectWordpressSeparatePageEta = createSelector(
  selectWordpressSeparatePageCalculationParams,
  selectOptionsPages,
  ({daysForExtraDay, coefficientCombinationSizes}, pages) => {
    const pagesHasPriceCustom = pages.find(page => page.priceIsCustom);
    const pagesHasMoreOne = pages.length > 1;
    const pagesTotal = pages.reduce((accumulator, {totalQuantity, durationValue}) => {
      accumulator = accumulator + (totalQuantity * durationValue);
      return accumulator;
    }, 0);
    const pagesTotalWithCoefficient = Math.ceil(pagesTotal * coefficientCombinationSizes);
    const eta = pagesHasMoreOne ? pagesTotalWithCoefficient + Math.floor(pagesTotalWithCoefficient / daysForExtraDay) : pagesTotal;
    const etaIsExists = !!eta;
    const etaText = pagesHasPriceCustom ? 'custom' : `${eta} business days`

    return {
      etaIsExists,
      etaText
    };
  }
);

export const selectWordpressSeparatePageDiscount = () => ({
  discountIsExists: false,
  discountText: '',
  discountPrice: 0,
});
